import React from "react";
import "./Button.scss";
import lockIco from "../../../../../../assets/lockIco.svg";
import LoaderSpin from "../../../../../../components/Loader/loaderSpin";

const Button = ({ active = true, text,isLoader, handeClick, className='' }) => {
  return (
    <button
      className={`button ${!active ? "button__selected" : ""} ${className}`}
      onClick={handeClick}
      disabled={active || isLoader}
    >
      {isLoader ? (
        <LoaderSpin size={30}/>
      ) : (
        <>
          {active && <img src={lockIco} alt="lock icon" />}
          <p className={`button__text ${!active ? "button__text__selected" : ""}`}>
            {text}
          </p>
        </>
      )}
    </button>
  );
};

export default Button;
